import { CSSProperties, useEffect, useState } from 'react';

const useDropdownResize = (): CSSProperties => {
  let requestAnimationFrameId;
  const [dropdownWidth, setDropdownWidth] = useState<number>(0);
  const dropdownMenuStyle: CSSProperties = dropdownWidth > 0 ? { width: dropdownWidth + 'px' } : {};

  // ドロップダウンメニューの横幅調整
  useEffect(() => {
    dropdownResize();
    window.addEventListener('resize', dropdownResize);
  }, []);

  const dropdownResize = (): void => {
    cancelAnimationFrame(requestAnimationFrameId);
    requestAnimationFrameId = requestAnimationFrame(() => {
      const domQuery = document.getElementById('query');
      if (domQuery) {
        let width = document.getElementById('query').clientWidth || 0;
        if (width !== dropdownWidth) {
          setDropdownWidth(width);
        }
      }
    });
  };

  return dropdownMenuStyle;
};

export default useDropdownResize;
